import { useState } from "react";

import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";

import { ITask } from "../../../data_models/task";
import { IProject } from "../../../data_models/project";
import useProjects from "../../../hooks/useProjects";

interface StartProjectWithPmLightboxProps {
    onClose: () => void;
    projectId: string;
    onProjectUpdate: (project: IProject) => void;
    onTasksUpdate: (tasks: ITask[]) => void;
}

const StartProjectWithPmLightbox: React.FC<StartProjectWithPmLightboxProps> = ({ onClose, projectId, onProjectUpdate, onTasksUpdate }) => {

    const [loading, setLoading] = useState(false);

    const { startProjectWithPm } = useProjects();
    const { addSuccessNotification } = useDisplayNotifications();

    const onStartProjectWithPm = async () => {
        setLoading(true);
        try {
            const { project, tasks } = await startProjectWithPm(projectId);
            if (project) {
                onProjectUpdate(project);
            }
            if (tasks) {
                onTasksUpdate(tasks);
            }
            addSuccessNotification("Project started successfully.");
        } catch (error: any) {
            // addErrorNotification(error.message);
        }
        setLoading(false);
        onClose();
    }


    return (
        <Lightbox
            header="Start Project"
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onStartProjectWithPm}
            confirmText="Start Project"
            loadingConfirm={loading}
            content={
                <div className="flex flex-col items-start space-y-3" >
                    <p>Your project manager will handle hiring the right talent and making sure everything gets done smoothly.
                        Once you start the project, you’ll be able to pay for tasks one by one. As soon as a task is paid, talent will be assigned and work can begin.</p>
                    <p className="italic">We’ll do our best to assign the PM who verified your project, but can’t guarantee it—please give us a bit to match you with the best available manager.</p>
                </div>
            }

        />

    );
}

export default StartProjectWithPmLightbox;